import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getRegisterData } from 'shared/store/auth/selectors'
import { LoadingStatus } from 'shared/types'
import { MODULE_NAME } from '../../strings'

export const useError = () => {
  const { t } = useTranslation(MODULE_NAME)
  const registerData = useSelector(getRegisterData)

  return registerData.loading === LoadingStatus.Failed
    ? t('register.errorMessage')
    : ''
}
